// import StageOne from "../Views/StageOne";
import Loader from "../Views/Loader";

const routes = [{ path: "/", element: <Loader /> }];

export default routes;
